import React from 'react';
import { Card, CardBody, CardTitle, Table } from 'reactstrap';

const dummyMedicineInfo = {
  dosageForm: 'Tablet',
  strength: '500mg',
  routeOfAdministration: 'Oral',
  medicineType: 'TabletPack',
  prescriptionRequired: false,
  description: 'A common pain reliever and fever reducer.',
};

const MedicineInfoCard = () => {
  const medicine = dummyMedicineInfo;

  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Medicine Information</CardTitle>
        <p className="text-muted mb-4">{medicine.description || 'No description available'}</p>
        <div className="table-responsive">
          <Table className="table-nowrap mb-0">
            <tbody>
              <tr>
                <th scope="row">Dosage Form:</th>
                <td>{medicine.dosageForm}</td>
              </tr>
              <tr>
                <th scope="row">Strength:</th>
                <td>{medicine.strength || 'N/A'}</td>
              </tr>
              <tr>
                <th scope="row">Route:</th>
                <td>{medicine.routeOfAdministration || 'N/A'}</td>
              </tr>
              <tr>
                <th scope="row">Type:</th>
                <td>{medicine.medicineType || 'N/A'}</td>
              </tr>
              <tr>
                <th scope="row">Prescription:</th>
                <td>{medicine.prescriptionRequired ? 'Required' : 'Not Required'}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

export default MedicineInfoCard;
